<div class="view">
  <div class="head">
    <app-breadcrumb [constructor_name]="constructor.name"></app-breadcrumb>
  </div>

  <div class="body">
    <div style="margin: 0px 0px -6.5px 0px">
      <img
        src="https://wikipapa.org/images/banner-nosotros-1.jpg"
        style="object-fit: contain; background-size: cover"
        width="100%"
      />
    </div>
    <!-- == -->
    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-around center"
      style="padding: 0% 15%; background-color: #f9efff"
    >
      <div style="text-align: center; padding-top: 3.5em">
        <span
          style="
            font-family: Raleway, sans-serif;
            color: #96007c;
            font-size: 36pt;
            line-height: 50pt;
            text-align: center;
          "
        >
          ¿Qué es WIKIPAPA?
        </span>
      </div>

      <div style="text-align: center; padding: 3em">
        <span
          style="
            font-family: Raleway, sans-serif;
            color: #96007c;
            font-size: 28pt;
            line-height: 50pt;
            text-align: center;
          "
        >
          En WIKIPAPA estamos apoyando a la consolidación de un sistema
          integrado que involucre a agricultores (guardianes de la papa),
          consumidores, estudiantes de secundaria, docentes e investigadores
          para conservar, monitorear la biodiversidad de papas nativas y poder
          llevarlos de la Granja a la Mesa a través del uso de diversas
          herramientas tecnológicas.
        </span>
      </div>
    </div>
    <br />
    <!-- == -->
    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-between center"
      style="background-color: #fff"
    >
      <div fxFlex="12.5"></div>
      <div fxFlex="25" fxFlex.sm="100" fxFlex.xs="100">
        <div style="margin: 0px 0px -6.5px 0px">
          <img
            src="https://wikipapa.org/images/foto-1-nosotros.jpg"
            style="object-fit: contain; background-size: cover"
            width="90%"
          />
        </div>
      </div>
      <div fxFlex="25" fxFlex.sm="100" fxFlex.xs="100">
        <div style="margin: 0px 0px -6.5px 0px">
          <img
            src="https://wikipapa.org/images/foto-2-nosotros.jpg"
            style="object-fit: contain; background-size: cover"
            width="90%"
          />
        </div>
      </div>
      <div fxFlex="25" fxFlex.sm="100" fxFlex.xs="100">
        <div style="margin: 0px 0px -6.5px 0px">
          <img
            src="https://wikipapa.org/images/foto-3-nosotros.jpg"
            style="object-fit: contain; background-size: cover"
            width="90%"
          />
        </div>
      </div>
      <div fxFlex="12.5"></div>
    </div>
    <br />
    <!-- == -->
    <div style="max-width: 1170px; margin: 0px auto; padding: 15px">
      <div fxLayout="row wrap" fxLayoutAlign="space-between stretch">
        <div fxFlex="100" style="padding: 2em 0em">
          <span
            style="
              font-family: Raleway, sans-serif;
              color: #96007c;
              font-size: 40pt;
              line-height: 50pt;
              text-align: center;
            "
          >
            Objetivo
          </span>
        </div>

        <div fxFlex="48" fxFlex.sm="100" fxFlex.xs="100">
          <span style="font-size: 1.8em">
            El objetivo es contribuir a la conservación in-situ de la diversidad
            de variedades endémicas de los Andes a través del monitoreo en
            tiempo real a través de una colaboración de ciencia ciudadana
            (ancianos, jóvenes, escuelas y técnicos), al tiempo que se
          </span>
        </div>
        <div fxFlex="2" style="border-right: solid 1px #96007c"></div>
        <div fxFlex="2" style="border-left: solid 1px #96007c"></div>
        <div fxFlex="48" fxFlex.sm="100" fxFlex.xs="100">
          <span style="font-size: 1.8em">
            proporciona información 'de la granja a la mesa' y los vínculos
            comerciales que permitan una compensación directa hacia los
            guardianes de la papa a través de precios superiores para las
            mezclas de papa.</span
          >
        </div>
      </div>
    </div>
    <br />
    <!-- == -->
    <div style="max-width: 1170px; margin: 0px auto; padding: 15px">
      <div fxLayout="row wrap" fxLayoutAlign="space-between center">
        <div fxFlex="100">
          <span
            style="
              font-family: Raleway, sans-serif;
              color: #96007c;
              font-size: 40pt;
              line-height: 50pt;
              text-align: center;
            "
          >
            Componentes del proyecto:
          </span>
        </div>
      </div>
    </div>
    <br />
    <!-- == -->
    <div style="margin: 0px 0px -6.5px 0px">
      <img
        src="https://wikipapa.org/images/banner-nosotros-2.jpg"
        style="object-fit: contain; background-size: cover"
        width="100%"
      />
    </div>
    <!-- == -->
  </div>
</div>
